export default '/build/a41fd9a3.svg'